export default __webpack_public_path__ + "static/media/icon-cart.00d4273c.svg";